angular.module('setting', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);


// WEBPACK FOOTER //
// ./src/app/service/setting/setting.module.js